import { AuditStationPage } from '@app/modules/audit/modules/station-audit/components/AuditStationPage';
import { StationMatchesListPage } from './StationMatchesListPage';

/**
 * Wraps the matches list page in the audit station layout for station-scoped audit routes.
 */
export function AuditMatchesPageAdapter() {
  return (
    <AuditStationPage>
      <StationMatchesListPage />
    </AuditStationPage>
  );
}
